import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const digestsNotificationsPersonalSettingsRoute: InvariantJiraRoute = {
	name: 'personal-settings-digests',
	path: '/jira/settings/personal/digests',
};
